/* global axios */
import ApiClient from './ApiClient';

// Mira's help for agents on a conversation (summary, answers, reply drafts
// for approval) and the knowledge approval queue. Relay never sends anything
// Mira writes until an agent approves it.
class MiraSupportAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get knowledgeUrl() {
    return `${this.baseUrl()}/mira_knowledge`;
  }

  show(conversationId) {
    return axios.get(`${this.url}/${conversationId}/mira_assist`);
  }

  summary(conversationId) {
    return axios.post(`${this.url}/${conversationId}/mira_assist/summary`);
  }

  answer(conversationId, question) {
    return axios.post(`${this.url}/${conversationId}/mira_assist/answer`, {
      question,
    });
  }

  suggestReply(conversationId) {
    return axios.post(
      `${this.url}/${conversationId}/mira_assist/suggest_reply`
    );
  }

  proposeKnowledge(conversationId) {
    return axios.post(
      `${this.url}/${conversationId}/mira_assist/propose_knowledge`
    );
  }

  approveDraft(conversationId, draftId, content) {
    return axios.post(
      `${this.url}/${conversationId}/mira_drafts/${draftId}/approve`,
      { content }
    );
  }

  discardDraft(conversationId, draftId) {
    return axios.post(
      `${this.url}/${conversationId}/mira_drafts/${draftId}/discard`
    );
  }

  knowledge(status) {
    return axios.get(this.knowledgeUrl, { params: { status } });
  }

  decideKnowledge(itemId, { decision, title, question, answer, note }) {
    return axios.post(
      `${this.knowledgeUrl}/${encodeURIComponent(itemId)}/decide`,
      { decision, title, question, answer, note }
    );
  }

  proposeArticles() {
    return axios.post(`${this.knowledgeUrl}/propose_articles`);
  }
}

export default new MiraSupportAPI();
